import { useEffect } from 'react';
import { useHistory } from 'app/components/router/History';
import { History } from 'app/services/history';

/**
 * Applies the given history service side effect appropriately while both client
 * rendering and server rendering.
 */
export default function useHistorySideEffect(
  callback: (history: History) => void,
  callbackDeps: unknown[],
): void {
  const history = useHistory();

  if (history.isServerRendering) {
    callback(history);
  }

  useEffect(() => {
    if (!history.isServerRendering) {
      callback(history);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, callbackDeps);
}
